import React from "react";
import { useFetchNew } from "../../data/fetch/useFetch";
import { getConfiguration } from "../../data/utils";
import { parseExtraEvents } from "../../data/parseExtraEvent";
import { usePrematchData } from ".././PrematchDataFetcher";
import Loader from "../../common/Loader";

function flattenArray(array) {
    const result = [];
    array.forEach(a =>
        result.push(...a)
    );
    return result;
}

export default function ExtraCotaFetcher(props) {
    const conf = getConfiguration();
    const prematchData = usePrematchData();

    const [isLoading, isError, data] = useFetchNew(conf.api.getExtraEvents, null, (data) => {
        data = parseExtraEvents(prematchData, data);
        data.cota = flattenArray(data.cota);
        data.extra = flattenArray(data.extra);
        return data;
    });

    if (isLoading || isError) {
        return <Loader isError={isError} />
    }

    return props.renderItem(data);
}
